import React, { useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom'
import { SurveyParamsContext } from './context/SurveyParamsContext'
import { useMobileRootClass } from './hooks/useMobileRootClass'
// import App_230724154617 from './metaage2023/App'
// import App_230814115714 from './P230814115714/App'
// import App_230919184319 from './P230919184319/App'
// import App_231019161346 from './P231019161346/App'
// import App_231024154343 from './P231024154343/App'
// import App_231026144422 from './P231026144422/App'
// import App_231026151746 from './P231026151746/App'
// import App_231101165555 from './P231101165555/App'
// import App_231108185428 from './P231108185428/App'
// import App_231113152849 from './P231113152849/App'
// import App_231103115448 from './P231103115448/App'
// import App_231122125054 from './P231122125054/App'
// import App_231122150020 from './P231122150020/App'
// import App_231129120002 from './P231129120002/App'
import Template from './template/Layout'
import P231220115743 from './P231220115743/Layout'
import P231222142335 from './P231222142335/Layout'
import P231226122153 from './P231226122153/Layout'
import P231226145800 from './P231226145800/Layout'
import P231228170224 from './P231228170224/Layout'
import P240103165422 from './P240103165422/Layout'
import P240108132902 from './P240108132902/Layout'
import P240226151347 from './P240226151347/Layout'
import P240304111433 from './P240304111433/Layout'
import P240305150522 from './P240305150522/Layout'
import P240305133844 from './P240305133844/Layout'
import P240321175847 from './P240321175847/Layout'
import P240322105620 from './P240322105620/Layout'
// import P240401164756 from './P240401164756/Layout'
import P240507153028 from './P240507153028/Layout'
import P240430105824 from './P240430105824/Layout'
import P240519092346 from './P240519092346/Layout'
import P240611161951 from './P240611161951/Layout'
import P240612121715 from './P240612121715/Layout'
import P240614183901 from './P240614183901/Layout'
import P240624112044 from './P240624112044/Layout'
import P240719175039533 from './P240719175039533/Layout'
import P240903105537546 from './P240903105537546/Layout'
import P240827173131128 from './P240827173131128/Layout'
import P241019171605981 from './P241019171605981/Layout'
import P241028095407578 from './P241028095407578/Layout'
import P241103190113942 from './P241103190113942/Layout'
import P241106165629144 from './P241106165629144/Layout'
import P241108105538703 from './P241108105538703/Layout'
import P241101120343121 from './P241101120343121/Layout'
import P241205140056176 from './P241205140056176/Layout'
// import P241210105102345 from './P241210105102345/Layout'
import P241213185147102 from './P241213185147102/Layout'
import P241220112137853 from './P241220112137853/Layout'
import P241223111701981 from './P241223111701981/Layout'
import P250108144702854 from './P250108144702854/Layout'
import P250208135816534 from './P250208135816534/Layout'
import P250213143136488 from './P250213143136488/Layout'
import P250307131040601 from './P250307131040601/Layout'
import P250319102610970 from './P250319102610970/Layout'
import P250321191530779 from './P250321191530779/Layout'
import P250325113730554 from './P250325113730554/Layout'
import P250327101045795 from './P250327101045795/Layout'
import P250423112413307 from './P250423112413307/Layout'
import P250425172755956 from './P250425172755956/Layout'
import P250519162854070 from './P250519162854070/Layout'
import P250526205237685 from './P250526205237685/Layout'
import P250528175251672 from './P250528175251672/Layout'
import P250603155903216 from './P250603155903216/Layout'
import P250605102036265 from './P250605102036265/Layout'
import P250704105151579 from './P250704105151579/Layout'
import P250704104557323 from './P250704104557323/Layout'
import P250722151031808 from './P250722151031808/Layout'
import P250730172908632 from './P250730172908632/Layout'
import P250721102427394 from './P250721102427394/Layout'
import P250724134115745 from './P250724134115745/Layout'
import P250807134936402 from './P250807134936402/Layout'
import P250807134941006 from './P250807134941006/Layout'
import P250807102214872 from './P250807102214872/Layout'
import P250807174602349 from './P250807174602349/Layout'
import P250807174603893 from './P250807174603893/Layout'
import P250811104747731 from './P250811104747731/Layout'
import P250820134856561 from './P250820134856561/Layout'
import P250819094832689 from './P250819094832689/Layout'
import P250819160416807 from './P250819160416807/Layout'
import P250828164404609 from './P250828164404609/Layout'
import P250911174349993 from './P250911174349993/Layout'
import P250919101714377 from './P250919101714377/Layout'
import P250922145835288 from './P250922145835288/Layout'
import P250805175342648 from './P250805175342648/Layout'
import P251008164611051 from './P251008164611051/Layout'
import P251008111441173 from './P251008111441173/Layout'
import P251009104657649 from './P251009104657649/Layout'
import P251030164036897 from './P251030164036897/Layout'
import P251104205255327 from './P251104205255327/Layout'
import P251105113927361 from './P251105113927361/Layout'
import P251112114550054 from './P251112114550054/Layout'
import P251113110520253 from './P251113110520253/Layout'
import P251118141015081 from './P251118141015081/Layout'
import P251126094126967 from './P251126094126967/Layout'
import P251210160216133 from './P251210160216133/Layout'
import P251221135934411 from './P251221135934411/Layout'
import P251110160042921 from './P251110160042921/Layout'
import P251112101443178 from './P251112101443178/Layout'
import P251111140616709 from './P251111140616709/Layout'
import P260105140447238 from './P260105140447238/Layout'
import P260114095521207 from './P260114095521207/Layout'
import P260122105456507 from './P260122105456507/Layout'
import P260107201146003 from './P260107201146003/Layout'
import P260122103032064 from './P260122103032064/Layout'
import P260224172250419 from './P260224172250419/Layout'
import P260302102034329 from './P260302102034329/Layout'
import P260209125852991 from './P260209125852991/Layout'
import P260203211703332 from './P260203211703332/Layout'
import P251111161052199 from './P251111161052199/Layout'
import P260401104012334 from './P260401104012334/Layout'
import P260409112831050 from './P260409112831050/Layout'
import P260407164822624 from './P260407164822624/Layout'
import P260420121318071 from './P260420121318071/Layout'
import P260422111828878 from './P260422111828878/Layout'
import P260424113023875 from './P260424113023875/Layout'
import P260423112959366 from './P260423112959366/Layout'
import P260504142323423 from './P260504142323423/Layout'
import P260506152100127 from './P260506152100127/Layout'
import P260507152321758 from './P260507152321758/Layout'
import P260521120747777 from './P260521120747777/Layout'
import P260521163517111 from './P260521163517111/Layout'
import P260518151015916 from './P260518151015916/Layout'
import Lottery from './lottery/Layout'
import P260511155227213 from './P260511155227213/Layout'
import P260601134150576 from './P260601134150576/Layout'
import P260528115639689 from './P260528115639689/Layout'
import P260601122243471 from './P260601122243471/Layout'
import P260623184722756 from './P260623184722756/Layout'
import P260623222642634 from './P260623222642634/Layout'
import P260601122243471Lottery from './P260601122243471/Lottery'
import P260513101648634 from './P260513101648634/Layout'
import P260508111254684 from './P260508111254684/Layout'
import P260611155440984 from './P260611155440984/Layout'
import P260707123320686 from './P260707123320686/Layout'
import P260424175235016 from './P260424175235016/Layout'
import P260417185311137 from './P260417185311137/Layout'
import P260713102823440 from './P260713102823440/Layout'
import P260708123235588 from './P260708123235588/Layout'
import P260720172622191 from './P260720172622191/Layout'
import P260714142147742 from './P260714142147742/Layout'
import P260714171008123 from './P260714171008123/Layout'
import P260708110355987 from './P260708110355987/Layout'
import P260727115651417 from './P260727115651417/Layout'
import P260720172319042 from './P260720172319042/Layout'
import P260722164808465 from './P260722164808465/Layout'
import P260602181534372 from './P260602181534372/Layout'
import P260813162943206 from './P260813162943206/Layout'
import P260731161746293 from './P260731161746293/Layout'
import P260803195458935 from './P260803195458935/Layout'
import P260730103149964 from './P260730103149964/Layout'
import P260807120029729 from './P260807120029729/Layout'
import P260812143206845 from './P260812143206845/Layout'
import P260812143247123 from './P260812143247123/Layout'
import P260812144112638 from './P260812144112638/Layout'
import P260813163032636 from './P260813163032636/Layout'
import P260817111456476 from './P260817111456476/Layout'
import P260820104155111 from './P260820104155111/Layout'
import P260821102805715 from './P260821102805715/Layout'
import P260907121939025 from './P260907121939025/Layout'
import P260907111101439 from './P260907111101439/Layout'
import P260902161053642 from './P260902161053642/Layout'
import P260817144403916 from './P260817144403916/Layout'
import P260911201213041 from './P260911201213041/Layout'
import P260914115448410 from './P260914115448410/Layout'
import P260914163614463 from './P260914163614463/Layout'
import P260917191016735 from './P260917191016735/Layout'
import P260910141531858 from './P260910141531858/Layout'
import Home from './home/App'
import Test from './test/Layout'
import IsSubmitted from './IsSubmitted'
import Closed from './Closed'
import Error from './Error'
import NotFound from './NotFound'
import MissingParams from './MissingParams'
import FormatError from './FormatError'
import Success from './Success'
import Computex from './Computex'
import SuccessComputex from './SuccessComputex'
import Computex2025 from './Computex2025'
import SuccessComputex2025 from './SuccessComputex2025'
import Computex2025GetGiftStatus from './Computex2025GetGiftStatus'
import SuccessDkabio from './SuccessDkabio'
import QuestionnaireSkipConverter from './QuestionnaireSkipConverter'
// example
import P230914102305 from './P230914102305/Layout'
import P240703185556 from './P240703185556/Layout'
import HaTask from './HaTask/Layout'
import HaTaskWithUserId from './HaTaskWithUserId/Layout'
import ezcLogo from './images/ezc-Logo-m.png'
import dkabioLogo from './images/DKABio-LOGO.png'

function App() {
  return (
    <Router basename={process.env.REACT_APP_BASENAME || ''}>
      <Content />
    </Router>
  )
}

function Content() {
  // 防止閃閃（全站共用，各問卷 Agree.js 不需再自行實作）
  useMobileRootClass()

  const [completionMessage, setCompletionMessage] = useState(
    `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或以手機點擊下載連結 <a href="https://ezc-appweb.dsigroup.com.tw/app.html" target="_blank">https://ezc-appweb.dsigroup.com.tw/app.html</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
  )
  const [isDkabio, setIsDkabio] = useState(false)
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const sfdSamplerId = searchParams.get('sfd_sampler_id') || null
  const sfdPId = searchParams.get('sfd_p_id') || null
  const userId = searchParams.get('user_id') || null

  useEffect(() => {
    if (location.pathname.includes('/ha')) {
      setIsDkabio(true)
    } else {
      setIsDkabio(false)
    }
  }, [location])

  const project = [
    {
      url: 'P250820134856561',
      title: '中式餐廳消費經驗調查',
      visible: false,
    },
  ]

  const ad = [
    {
      title: '女性內衣市場研究 受訪者招募中',
      description: '‼️徵求20-40歲女性消費者！完整參與，參與費3,500元‼️',
      url: 'https://www.surveycake.com/s/M6aY3',
      visible: true,
      endDate: '2025-04-12',
    },
  ]
  // 宗教問卷
  const religiousSurveyIds = [
    'P240415150907',
    'P240415150904',
    'P240415150901',
    'P240415150858',
    'P240415150855',
    'P240415150852',
    'P240415150849',
    'P240415150846',
    'P240415150843',
    'P240415150840',
    'P240415150837',
    'P240415150834',
    'P240415150831',
    'P240415150828',
    'P240415150825',
    'P240415150822',
    'P240415150819',
    'P240415150816',
    'P240415150813',
    'P240415150810',
    'P240415150807',
    'P240415150804',
    'P240415150801',
    'P240415150758',
    'P240415150755',
    'P240415150752',
    'P240415150749',
    'P240415150746',
    'P240415150743',
    'P240415150740',
    'P240415150737',
    'P240415150734',
    'P240415150731',
    'P240415150728',
    'P240415150725',
    'P240415150722',
    'P240415150719',
    'P240415150716',
    'P240415150713',
    'P240415150710',
    'P240415150707',
    'P240415150704',
    'P240415150701',
    'P240415150658',
    'P240415150655',
    'P240415150652',
    'P240415150649',
    'P240415150646',
    'P240415150643',
    'P240415150640',
    'P240415150637',
    'P240415150634',
    'P240415150631',
    'P240415150628',
    'P240415150625',
    'P240415150622',
    'P240415150619',
    'P240415150616',
    'P240415150613',
    'P240415150610',
    'P240415150607',
    'P240415150604',
    'P240415150601',
    'P240415150558',
    'P240415150555',
    'P240415150552',
    'P240415150549',
    'P240415150546',
    'P240415150543',
    'P240415150540',
    'P240415150537',
    'P240415150534',
    'P240415150531',
    'P240415150528',
    'P240415150525',
    'P240415150522',
    'P240415150519',
    'P240415150516',
    'P240415150513',
    'P240415150510',
    'P240415150507',
    'P240415150504',
    'P240415150501',
    'P240415150458',
    'P240415150455',
    'P240415150452',
    'P240415150449',
    'P240415150446',
    'P240415150443',
    'P240415150440',
    'P240415150437',
    'P240415150434',
    'P240415150431',
    'P240415150428',
    'P240415150425',
    'P240412180903',
    'P240412180902',
    'P240412180901',
    'P240412180859',
    'P240412180857',
    'P240529165658',
    'P240529165655',
    'P240529165654',
    'P240529165652',
    'P240529165651',
    'P240529165650',
    'P240529165649',
    'P240529165647',
    'P240529165646',
    'P240529165645',
    'P240529165644',
    'P240529165643',
    'P240529165642',
    'P240529165641',
    'P240529165640',
    'P240529165639',
    'P240529165638',
    'P240529165637',
    'P240529165636',
    'P240529165635',
  ]

  // 兒少福利
  const childWelfareIds = [
    'P240524121629',
    'P240524121628',
    'P240524121627',
    'P240524121626',
    'P240524121625',
    'P240524121624',
    'P240524121623',
    'P240524121622',
    'P240524121621',
    'P240524121620',
    'P240524121619',
    'P240524121618',
    'P240524121617',
    'P240524121616',
    'P240524121614',
    'P240523110323',
    'P240523110322',
    'P240523110321',
    'P240523110320',
    'P240523110319',
    'P240523110318',
    'P240523110317',
    'P240523110316',
    'P240523110315',
    'P240523110314',
    'P240523110312',
    'P240523110311',
    'P240523110252',
    'P240523110251',
    'P240523110250',
    'P240523110248',
    'P240523110247',
    'P240523110246',
    'P240523110245',
    'P240523110243',
    'P240523110242',
    'P240523110240',
    'P240523110239',
    'P240519092346',
  ]

  const notUsedIds = [
    // 網紅隨機剩下的不要顯示
    'P240910172157716',
    'P240910172156537',
    'P240910172155417',
    'P240910172154080',
    'P240910172136035',
    'P240910172134591',
    'P240910172132981',
    // 城市動態隨機剩下的不要顯示
    'P250620180312392',
    'P250620180311168',
    'P250620180310078',
    'P250620180308763',
    'P250620180307546',
    'P250620180305087',
    'P250620180306239',
    // 粉絲購票與接觸黃牛經驗調查 隨機剩下的不要顯示
    'P260818103532680',
    'P260818103653739',
  ]

  // 有流水編號的
  const routesConfigWithSerialNum = [
    // {
    //   path: '/p230914102305',
    //   component: P230914102305,
    //   title: '測試問卷',
    // },
  ]
  const routesConfig = [
    {
      path: '/p240611161951',
      component: P240611161951,
      title: '邁達特職工福利滿意度',
    },
    {
      path: '/p240612121715',
      component: P240612121715,
      title: '壯世代之創業規劃',
    },
    {
      path: '/p240614183901',
      component: P240614183901,
      title: 'DKABio Light即時智慧健康風險分析',
    },
    {
      path: '/p240624112044',
      component: P240624112044,
      title: '公司福利滿意度問卷',
    },
    {
      path: '/chimei',
      component: P240719175039533,
      title: 'DKABio Light即時智慧健康風險分析',
    },
    {
      path: '/p240903105537546',
      component: P240903105537546,
      title: 'DKABio Light即時智慧健康風險分析',
    },
    {
      path: '/p240830163849968',
      component: P240108132902,
      title: '宗教調查的一般民眾後續補樣',
    },
    {
      path: '/p240827173131128',
      component: P240827173131128,
      title: '中信科大新生健檢健康問卷',
    },
    {
      path: '/P241019171605981',
      component: P241019171605981,
      title: '揭曉您心目中完美坐駕的秘密！',
    },
    {
      path: '/P241028095407578',
      component: P241028095407578,
      title: '2024台灣民主韌性調查問卷',
    },
    {
      path: '/P241103190113942',
      component: P241103190113942,
      title: '高敏感男性陽剛氣質的探索性研究',
    },
    {
      path: '/P241106165629144',
      component: P241106165629144,
      title: 'AiEZ TRADE 網站體驗調查',
    },
    {
      path: '/P241101120343121',
      component: P241101120343121,
      title: '國健署調查',
    },
    {
      path: '/P241205140056176',
      component: P241205140056176,
      title: '合利他命',
    },
    {
      path: '/P241210105102345',
      component: P241213185147102,
      title: '職場能量大調查',
    },
    {
      path: '/P241213185147102',
      component: P241213185147102,
      title: '職場能量大調查(2)',
    },
    {
      path: '/P241220112137853',
      component: P241220112137853,
      title: '高敏感男性陽剛氣質的探索性研究正式',
    },
    {
      path: '/P241223111701981',
      component: P241223111701981,
      title: '保健食品消費者一對一訪談',
    },
    {
      path: '/P250108144702854',
      component: P250108144702854,
      title: '探討新科技使用行為對成功老化之影響',
    },
    {
      path: '/P250208135816534',
      component: P250208135816534,
      title: '2025 邁達特員工滿意度問卷',
    },
    {
      path: '/P250213143136488',
      component: P250213143136488,
      title: '2025 台灣民眾網路使用習慣與各項公共議題觀點調查',
    },
    {
      path: '/P250306115930849',
      component: P250213143136488,
      title: '2025 台灣民眾網路使用習慣與各項公共議題觀點調查',
    },
    {
      path: '/P250307131040601',
      component: P250307131040601,
      title: '新光人壽意外險廣告後測',
    },
    {
      path: '/P250319102610970',
      component: P250319102610970,
      title: '女性內衣市場研究',
    },
    {
      path: '/P250321191530779',
      component: P250321191530779,
      title: '膠原蛋白食用經驗座談會',
    },
    {
      path: '/P250325113730554',
      component: P250325113730554,
      title: '社群媒體影響者與產品品牌代言效果關係',
    },
    {
      path: '/P250327101045795',
      component: P250327101045795,
      title: '我國工作條件調查',
    },
    {
      path: '/P250425172755956',
      component: P250425172755956,
      title: '我國工作條件調查-測試版 1',
    },
    {
      path: '/P250519162854070',
      component: P250519162854070,
      title: '我國工作條件調查-測試版 2',
    },
    {
      path: '/P250526205237685',
      component: P250526205237685,
      title: '濕式衛生紙消費者行為與購買行為之研究',
    },
    {
      path: '/P250605102036265',
      component: P250605102036265,
      title: '動態城市感知的建構並評估噪音對民眾的健康風險',
    },
    {
      path: '/P250704105151579',
      component: P250704105151579,
      title: '寬頻網路使用經驗座談會報名（凱擘）',
    },
    {
      path: '/P250704104557323',
      component: P250704104557323,
      title: '＊寬頻網路使用經驗座談會報名（退拆）',
    },
    {
      path: '/P250704104919283',
      component: P250704105151579,
      title: '✦寬頻網路使用經驗座談會報名（台灣）',
    },
    {
      path: '/P250807134941006',
      component: P250807134941006,
      title: '＊寬頻網路使用經驗座談會報名（退拆）',
    },
    {
      path: '/P250807134936402',
      component: P250807134936402,
      title: '✦寬頻網路使用經驗座談會報名（台灣）',
    },
    // {
    //   path: '/P250603155903216',
    //   component: P250603155903216,
    //   title: '我國工作條件調查-分頁版',
    // },
    // ========================
    {
      path: '/p230914102305',
      component: P230914102305,
      title: '測試問卷',
    },
    {
      path: '/P250528175251672',
      component: P250528175251672,
      title: '暫存功能測試',
    },
    {
      path: '/P250721163228510',
      component: P250307131040601,
      title: '貝立德',
    },
    {
      path: '/P250722151031808',
      component: P250722151031808,
      title: '114年即時通訊軟體民眾滿意度調查',
    },
    {
      path: '/P250730172908632',
      component: P250730172908632,
      title: '矩陣顯示測試',
    },
    {
      path: '/P250721102427394',
      component: P250721102427394,
      title: '享鴨',
    },
    {
      path: '/P250807174602349',
      component: P250807174602349,
      title: '享鴨(沒有帶入帶出版)',
    },
    {
      path: '/P250807174603893',
      component: P250807174603893,
      title: '享鴨(測試以上皆非版)',
    },
    {
      path: '/P250820134856561',
      component: P250820134856561,
      title: '享鴨(測試以上皆非版2)',
    },
    {
      path: '/P250724134115745',
      component: P250724134115745,
      title: '台灣民眾資訊習慣與公共議題變遷調查',
    },
    {
      path: '/P250807102214872',
      component: P250807102214872,
      title: '音樂串流平台試用經驗大調查',
    },
    {
      path: '/P250811104747731',
      component: P250811104747731,
      title: '保健意識大調查',
    },
    {
      path: '/P250819094832689',
      component: P250819094832689,
      title: '114年資安人才需求調查_資安產業',
    },
    {
      path: '/P250819160416807',
      component: P250819160416807,
      title: '護脊書包使用調查',
    },
    {
      path: '/P250828164404609',
      component: P250828164404609,
      title: '114年資安人才需求調查_產業資安(2)',
    },
    {
      path: '/P250911174349993',
      component: P250911174349993,
      title: '存款保險認知度調查',
    },
    {
      path: '/P250919101714377',
      component: P250919101714377,
      title: '2025 邁達特員工滿意度問卷',
    },
    {
      path: '/P250922145835288',
      component: P250922145835288,
      title: '【介紹版】輕鬆背!護脊書包消費調查',
    },
    {
      path: '/P250805175342648',
      component: P250805175342648,
      title: '114年高放選址立法草案調查問卷',
    },
    {
      path: '/P251008164611051',
      component: P251008164611051,
      title: '抗氧化守護者心理測驗',
    },
    {
      path: '/P251008111441173',
      component: P251008111441173,
      title: '114年臺北市兒童及少年生活狀況調查',
    },
    {
      path: '/P251009104657649',
      component: P251009104657649,
      title: '寬頻網路/有線電視選購經驗座談會',
    },
    {
      path: '/P251030164036897',
      component: P251030164036897,
      title: '臺灣地區婦女生育意願網路調查',
    },
    {
      path: '/P251104205255327',
      component: P251104205255327,
      title: '2026台灣民主韌性調查問卷',
    },
    {
      path: '/P251105113927361',
      component: P251105113927361,
      title: '全家鮮食第二次線上問卷',
    },
    {
      path: '/P251112131710139',
      component: P251104205255327,
      title: '2026台灣民主韌性調查問卷-正式',
    },
    {
      path: '/P251112114550054',
      component: P251112114550054,
      title: '[今晚吃什麼?]座談會',
    },
    {
      path: '/P251113110520253',
      component: P251113110520253,
      title: '【今天保養關節了嗎？】保健食品座談會',
    },
    {
      path: '/P251118141015081',
      component: P251118141015081,
      title: '你心中的夢想車，是這台嗎？',
    },
    {
      path: '/P251126094126967',
      component: P251126094126967,
      title: '你心中的理想銀行是什麼樣子？',
    },
    {
      path: '/P251210160216133',
      component: P251210160216133,
      title: '矩陣跳題',
    },
    {
      path: '/P251221135934411',
      component: P251221135934411,
      title: '你心中的夢想車，是這台嗎？',
    },
    {
      path: '/P251229220318666',
      component: P251126094126967,
      title: '你心中的理想銀行是什麼樣子？',
    },
    {
      path: '/P251110160042921',
      component: P251110160042921,
      title: '苗栗苑裡_(1a) 0~未滿3歲兒童',
    },
    {
      path: '/P260203211703332',
      component: P260203211703332,
      title: '苗栗苑裡_(1b) 3~未滿6歲兒童',
    },
    {
      path: '/P251111140616709',
      component: P251111140616709,
      title: '苗栗苑裡_(2)老人照顧',
    },
    {
      path: '/P251111161052199',
      component: P251111161052199,
      title: '苗栗苑裡_(3)障礙者',
    },
    {
      path: '/P251112101443178',
      component: P251112101443178,
      title: '苗栗苑裡_(4)照顧者問卷',
    },
    {
      path: '/P260105140447238',
      component: P260105140447238,
      title: '青年族群網路調查',
    },
    {
      path: '/P260114095521207',
      component: P260114095521207,
      title: '民眾對北宜新鐵路運輸服務看法',
    },
    {
      path: '/P260317143444633',
      component: P260114095521207,
      title: '民眾對北宜新鐵路運輸服務看法2',
    },
    {
      path: '/P260317143447266',
      component: P260114095521207,
      title: '民眾對北宜新鐵路運輸服務看法3',
    },
    {
      path: '/P260122105456507',
      component: P260122105456507,
      title: '睡眠保健食品調查問卷',
    },
    {
      path: '/P260107201146003',
      component: P260107201146003,
      title: '113年原住民族企業狀況調查',
    },
    {
      path: '/P260209125852991',
      component: P260209125852991,
      title: '113年原住民族企業狀況調查(訪員練習)',
    },
    {
      path: '/P260302131811720',
      component: P260107201146003,
      title: '113年原住民族企業狀況調查(訪員)',
    },
    {
      path: '/P260316192046484',
      component: P260122103032064,
      title: '國民健康混合模式訪問調查',
    },
    {
      path: '/P260224172250419',
      component: P260224172250419,
      title: '數位金融AI應用',
    },
    {
      path: '/P260302102034329',
      component: P260302102034329,
      title: '青年族群網路調查',
    },
    {
      path: '/P260401104012334',
      component: P260401104012334,
      title: '中高齡及高齡者就業市場供需概況調查',
    },
    {
      path: '/P260409112831050',
      component: P260409112831050,
      title: '115年即時通訊軟體民眾滿意度調查',
    },
    {
      path: '/P260413172155392',
      component: P260409112831050,
      title: '115年即時通訊軟體民眾滿意度調查',
    },
    {
      path: '/P260407164822624',
      component: P260407164822624,
      title: '[重點區]客家人口調查',
    },
    {
      path: '/P260420121318071',
      component: P260420121318071,
      title: '典通IRB人體試驗研究課程-自付醫療費用家戶面訪調查',
    },
    {
      path: '/P260422111828878',
      component: P260422111828878,
      title: '表演藝術活動參與經驗調查(測試)',
    },
    {
      path: '/P260429151327750',
      component: P260422111828878,
      title: '＃表演藝術活動參與經驗調查(非會員)',
    },
    {
      path: '/P260429151432411',
      component: P260422111828878,
      title: '✦表演藝術活動參與經驗調查(1有轉換潛力)',
    },
    {
      path: '/P260429151528732',
      component: P260422111828878,
      title: '✧表演藝術活動參與經驗調查(2轉換成功)',
    },
    {
      path: '/P260429151630813',
      component: P260422111828878,
      title: '➤表演藝術活動參與經驗調查(3續會成功)',
    },
    {
      path: '/P260429151722397',
      component: P260422111828878,
      title: '➢表演藝術活動參與經驗調查(4中斷付費)',
    },
    {
      path: '/P260424113023875',
      component: P260424113023875,
      title: '品牌評價與消費行為調查',
    },
    {
      path: '/P260423112959366',
      component: P260423112959366,
      title: '零食座談會報名',
    },
    {
      path: '/P260504142323423',
      component: P260504142323423,
      title: '台積心築藝術季活動參與調查',
    },
    {
      path: '/P260506152100127',
      component: P260506152100127,
      title:
        '［前測］衛福部115年兒童及少年生活狀況調查（6~未滿12歲國小兒童家長問卷）',
    },
    {
      path: '/P260507152321758',
      component: P260507152321758,
      title: '［前測］衛福部115年兒童及少年生活狀況調查（12~未滿18歲少年問卷）',
    },
    {
      path: '/P260521120747777',
      component: P260521120747777,
      title: '隨機選項',
    },
    {
      path: '/P260521163517111',
      component: P260521163517111,
      title: '靜穎測試選項隨機問題',
    },
    {
      path: '/P260518151015916',
      component: P260518151015916,
      title: '你心中的夢想車，是這台嗎？',
    },
    {
      path: '/P260511155227213',
      component: P260511155227213,
      title: '便利商店調查(使用P260601094113927)',
    },
    {
      path: '/P260527102817032',
      component: P260511155227213,
      title: '便利商店調查',
    },
    {
      path: '/P260601134150576',
      component: P260601134150576,
      title: '便利商店調查(典通)',
    },
    {
      path: '/P260528115639689',
      component: P260528115639689,
      title: '【魚油保健食品座談會】現正招募中！',
    },
    {
      path: '/P260601122243471',
      component: P260623222642634,
      title: '國民健康混合模式訪問調查(18-64歲)',
    },
    {
      path: '/P260623184722756',
      component: P260623184722756,
      title: '民眾對再生能源議題的看法調查',
    },
    {
      path: '/P260623222642634',
      component: P260623222642634,
      title: '國民健康混合模式訪問調查(18-64歲)[測試版]',
    },
    {
      path: '/P260601122243471/lottery',
      component: P260601122243471Lottery,
      title: '週週抽｜國民健康混合模式訪問調查',
    },
    {
      path: '/P260513101648634',
      component: P260513101648634,
      title: '115年臺北市身心障礙者生活狀況調查_B表',
    },
    {
      path: '/P260508111254684',
      component: P260508111254684,
      title: '115年臺北市身心障礙者生活狀況調查_A表',
    },
    {
      path: '/P260617154306861',
      component: P260513101648634,
      title: '【訪訓】115年臺北市身心障礙者生活狀況調查_B表(2)',
    },
    {
      path: '/P260617154257989',
      component: P260508111254684,
      title: '115年臺北市身心障礙者生活狀況調查_A表(2)',
    },
    {
      path: '/P260611155440984',
      component: P260611155440984,
      title: '海苔消費習慣大調查',
    },
    {
      path: '/P260424175235016',
      component: P260424175235016,
      title: '育嬰留職停薪_3到6歲問卷_前測',
    },
    {
      path: '/P260417185311137',
      component: P260417185311137,
      title: '育有0到3歲子女者問卷_前測',
    },
    {
      path: '/P260707123320686',
      component: P260707123320686,
      title: '育嬰留停照顧彈性化調查_育有0到3歲子女之勞工問卷',
    },
    {
      path: '/P260713102823440',
      component: P260713102823440,
      title: '國民健康混合模式訪問調查',
    },
    {
      path: '/P260708123235588',
      component: P260708123235588,
      title: '育嬰留停照顧彈性化調查_育有3到6歲子女之勞工問卷',
    },
    {
      path: '/P260716142632025',
      component: P260407164822624,
      title: '[重點區]客家人口調查',
    },
    {
      path: '/P260720172622191',
      component: P260720172622191,
      title: '苗栗苑裡_兒童的照顧者',
    },
    {
      path: '/P260714142147742',
      component: P260714142147742,
      title: '115年資安產業人才需求調查',
    },
    {
      path: '/P260714171008123',
      component: P260714171008123,
      title: 'AI與健康資訊研究搜尋',
    },
    {
      path: '/P260708110355987',
      component: P260708110355987,
      title:
        '［前測］衛福部115年兒童及少年生活狀況調查（0~未滿6歲國小兒童家長問卷）',
    },
    {
      path: '/P260727115651417',
      component: P260727115651417,
      title: '[模式2-現場填寫版]國民健康混合模式訪問調查',
    },
    {
      path: '/P260720172319042',
      component: P260720172319042,
      title: '115年身心障礙者生活狀況及需求調查 B表 主要家庭照顧者',
    },
    {
      path: '/P260722164808465',
      component: P260722164808465,
      title: '115年臺北市婦女生活狀況調查問卷',
    },
    {
      path: '/P260602181534372',
      component: P260602181534372,
      title: '115年身心障礙者生活狀況及需求調查-A表',
    },
    // 跳題邏輯複製自上面這支（A表），獨立 Agree.js 便於日後分開調整
    {
      path: '/P260813162943206',
      component: P260813162943206,
      title: '115年身心障礙者生活狀況及需求調查訪問表_A表測試',
    },
    {
      path: '/P260731161746293',
      component: P260731161746293,
      title: '串流平台對電影院觀影行為調查',
    },
    {
      path: '/P260803195458935',
      component: P260803195458935,
      title: '初探以生成式AI搜尋健康資訊的使用效果',
    },
    {
      path: '/P260730103149964',
      component: P260730103149964,
      title: '花卉購買和使用看法調查',
    },
    {
      path: '/P260807120029729',
      component: P260807120029729,
      title: '育嬰留停照顧彈性化調查_育有3到6歲子女之勞工網路問卷',
    },
    {
      path: '/P260812143206845',
      component: P260812143206845,
      title: '花卉、盆栽購買習慣大調查',
    },
    // P260812143247123 題目與 P260730103149964 相同，但篩出年齡層不同（自建 Agree.js）
    {
      path: '/P260812143247123',
      component: P260812143247123,
      title: '你平常會買花或盆栽嗎？',
    },
    // P260812144112638 題目與 P260730103149964 相同，但第3題地區只收台東縣、花蓮縣（自建 Agree.js）
    {
      path: '/P260812144112638',
      component: P260812144112638,
      title: '你會買花或盆栽嗎？一起來分享',
    },
    // 跳題邏輯複製自 P260720172319042（B表），獨立 Agree.js 便於日後分開調整
    {
      path: '/P260813163032636',
      component: P260813163032636,
      title: '115年身心障礙者生活狀況及需求調查訪問表_B表測試',
    },
    {
      path: '/P260817111456476',
      component: P260817111456476,
      title: '粉絲購票與接觸黃牛經驗調查A',
    },
    // 題目與 P260730103149964 相同，但第2題年齡只收 60-79 歲（自建 Agree.js）
    {
      path: '/P260820104155111',
      component: P260820104155111,
      title: '花卉、盆栽購買和使用看法調查',
    },
    // 跳題邏輯複製自 P260407164822624（[重點區]客家人口調查），第4題出生年相關顯示條件不同
    {
      path: '/P260821102805715',
      component: P260821102805715,
      title: '[重點區補樣]客家人口調查',
    },
    {
      path: '/P260907121939025',
      component: P260907121939025,
      title: '[test-T0-T2]北藝互動心聲大募集',
    },
    {
      path: '/P260907111101439',
      component: P260907111101439,
      title: '[test-T3-T5]北藝互動心聲大募集',
    },
    {
      path: '/P260902161053642',
      component: P260902161053642,
      title: '［正式］衛福部115年兒童及少年生活狀況調查（0~未滿6歲學齡前兒童家長問卷）',
    },
    {
      path: '/P260817144403916',
      component: P260817144403916,
      title: '［正式］衛福部115年兒童及少年生活狀況調查（12~未滿18歲少年問卷）',
    },
    {
      path: '/P260917170004168',
      // 正式版（T0-T2），與 [test-T0-T2] P260907121939025 共用邏輯
      component: P260907121939025,
      title: '✦北藝互動心聲大募集',
    },
    {
      path: '/P260917170250431',
      // 正式版（T0-T2），與 [test-T0-T2] P260907121939025 共用邏輯
      component: P260907121939025,
      title: '＃北藝互動心聲大募集',
    },
    {
      path: '/P260917170334671',
      // 正式版（T0-T2），與 [test-T0-T2] P260907121939025 共用邏輯
      component: P260907121939025,
      title: '✧北藝互動心聲大募集',
    },
    {
      path: '/P260917170449164',
      // 正式版（T3-T5），與 [test-T3-T5] P260907111101439 共用邏輯
      component: P260907111101439,
      title: '➠北藝互動心聲大募集',
    },
    {
      path: '/P260917170547702',
      // 正式版（T3-T5），與 [test-T3-T5] P260907111101439 共用邏輯
      component: P260907111101439,
      title: '➣北藝互動心聲大募集',
    },
    {
      path: '/P260917170625765',
      // 正式版（T3-T5），與 [test-T3-T5] P260907111101439 共用邏輯
      component: P260907111101439,
      title: '➤北藝互動心聲大募集',
    },
    {
      path: '/P260917191016735',
      // 複製 P260722164808465 的邏輯，但少了第一題（同意書），題號 -1
      component: P260917191016735,
      title: '［訪員版］115年臺北市婦女生活狀況調查問卷',
    },
    {
      path: '/P260911201213041',
      component: P260911201213041,
      title: '逆齡保養大調查！【抗老化保健座談會】招募中',
    },
    {
      path: '/P260914115448410',
      component: P260914115448410,
      title: '逆齡保養大調查！【抗老化保健座談會】招募至10/8',
    },
    {
      path: '/P260918144710666',
      // 與 P260911201213041 共用跳題邏輯
      component: P260911201213041,
      title: '◼日常保養大調查！【日常生活保健座談會】招募中',
    },
    {
      path: '/P260918144728939',
      // 與 P260911201213041 共用跳題邏輯
      component: P260911201213041,
      title: '❖日常保養大調查！【日常生活保健座談會】招募中',
    },
    {
      path: '/P260918145626537',
      // 與 P260911201213041 共用跳題邏輯
      component: P260911201213041,
      title: '⧱日常保養大調查！【日常生活保健座談會】招募中',
    },
    {
      path: '/P260914163614463',
      component: P260914163614463,
      title: '女性私密保健座談會報名',
    },
    {
      path: '/P260918153840125',
      // 與 P260914163614463 共用跳題邏輯
      component: P260914163614463,
      title: '妳的私密日常保健座談會報名',
    },
    {
      path: '/P260918154335043',
      // 與 P260914163614463 共用跳題邏輯
      component: P260914163614463,
      title: '私密保健有哪些座談會報名',
    },
    {
      path: '/P260910141531858',
      component: P260910141531858,
      title: '客家社會文化意向與態度調查',
    },
  ]

  return (
    <SurveyParamsContext.Provider value={{ userId, sfdPId, sfdSamplerId }}>
      <Routes>
        {routesConfig.map(({ path, component: Component }) => (
          <Route
            key={path}
            path={path}
            element={<Component setCompletionMessage={setCompletionMessage} />}
          />
        ))}

        {/* 便利商店調查 真實 pid 轉址到對外網址 */}
        <Route
          path="/P260601094113927"
          element={<Navigate to="/P260511155227213" replace />}
        />

        {/* <Route path="/p230724154617/*" element={<App_230724154617 />} />
          <Route path="/p230814115714/*" element={<App_230814115714 />} />
          <Route path="/p230919184319/*" element={<App_230919184319 />} />
          <Route path="/p231019161346/*" element={<App_231019161346 />} />
          <Route path="/p231024154343/*" element={<App_231024154343 />} />
          <Route path="/p231026144422/*" element={<App_231026144422 />} /> 
          <Route path="/p231026151746/*" element={<App_231026151746 />} />
          <Route path="/p231101165555/*" element={<App_231101165555 />} />
          <Route path="/p231108185428/*" element={<App_231108185428 />} />
          <Route path="/p231113152849/*" element={<App_231113152849 />} />
          <Route path="/p231103115448/*" element={<App_231103115448 />} />
          <Route path="/p231122125054/*" element={<App_231122125054 />} />
          <Route path="/p231122150020/*" element={<App_231122150020 />} /> 
          <Route path="/p231129120002/*" element={<App_231129120002 />} />*/}
        <Route path="/p231220115743" element={<P231220115743 />} />
        <Route path="/p231222142335" element={<P231222142335 />} />
        <Route path="/p231226122153" element={<P231226122153 />} />
        <Route path="/p231226145800" element={<P231226145800 />} />
        <Route path="/p231228170224" element={<P231228170224 />} />
        <Route path="/p240103165422" element={<P240103165422 />} />
        <Route
          path="/p240108132902"
          element={
            <P240108132902 setCompletionMessage={setCompletionMessage} />
          }
        />
        {/* 宗教調查的一般民眾後續補樣 */}
        {/* <Route
            path="/P240830163849968"
            element={
              <P240108132902 setCompletionMessage={setCompletionMessage} />
            }
          /> */}
        <Route path="/p240226151347" element={<P240226151347 />} />
        <Route path="/p240304111433" element={<P240304111433 />} />
        <Route path="/p240305150522" element={<P240305150522 />} />
        <Route path="/p240305133844" element={<P240305133844 />} />
        <Route path="/p240321175847" element={<P240321175847 />} />
        <Route path="/p240322105620" element={<P240322105620 />} />
        {/* <Route path="/p240401164756" element={<P240401164756 />} /> */}
        <Route
          path="/p240430105824"
          element={
            <P240430105824 setCompletionMessage={setCompletionMessage} />
          }
        />
        <Route
          path="/p240430105853"
          element={
            <P240430105824 setCompletionMessage={setCompletionMessage} />
          }
        />
        {/* 2025 computex */}
        <Route
          path="/P250423112413307"
          element={
            <P250423112413307 setCompletionMessage={setCompletionMessage} />
          }
        />
        {/* 英文版 */}
        <Route
          path="/P250424001910598"
          element={
            <P250423112413307 setCompletionMessage={setCompletionMessage} />
          }
        />
        {/* ======== 便利商店 ========*/}
        <Route
          path="/p240507153028"
          element={
            <P240507153028 setCompletionMessage={setCompletionMessage} />
          }
        />
        <Route
          path="/p240515191226"
          element={
            <P240507153028 setCompletionMessage={setCompletionMessage} />
          }
        />

        {/* ======== 兒少福利 ========*/}
        {childWelfareIds.map((v) => {
          return (
            <Route
              key={v}
              path={`/${v}`}
              element={
                <P240519092346 setCompletionMessage={setCompletionMessage} />
              }
            />
          )
        })}

        {/* ======== 網紅剩下的 route 不顯示 ========*/}
        {notUsedIds.map((v) => {
          return <Route key={v} path={`/${v}`} element={<NotFound />} />
        })}

        {/* ======== 宗教 ========*/}
        {religiousSurveyIds.map((v) => {
          return <Route key={v} path={`/${v}`} element={<P240226151347 />} />
        })}

        {/* ======== 抽獎老虎機 ========*/}
        {/* 測試網址：http://localhost:3000/ezc-survey-dev/lottery/MG260508150508047/AbJb6Ase/e4616888e2e3bbdbb20e0fde51888d750a8f2a3f27aaff4d69979222de22d608 */}
        <Route path="/lottery/:game_id/:ac/:se" element={<Lottery />} />

        {/* <Route path="/:pid" element={<Template />} /> */}
        <Route
          path="/:pid"
          element={
            <Template
              isDkabio={isDkabio}
              setIsDkabio={setIsDkabio}
              setCompletionMessage={setCompletionMessage}
            />
          }
        />

        {/* ============ 404 回首頁 ============ */}

        <Route index element={<Home project={project} ad={ad} />} />
        <Route path="/test/*" element={<Test />} />
        <Route path="/computex-2024" element={<Computex />} />
        <Route path="/computex-2025" element={<Computex2025 />} />

        {/* ======== 測試問卷 ========*/}
        {/* <Route
            path="/p230914102305/:serial_num"
            element={
              <P230914102305 setCompletionMessage={setCompletionMessage} />
            }
          /> */}

        <Route path="/:pid/closed" element={<Closed />} />
        <Route path="/:pid/done" element={<IsSubmitted />} />
        <Route path="/:pid/submitFail" element={<Error />} />
        <Route path="/ha/:pid/submitFail" element={<Error />} />
        <Route path="/:pid/notFound" element={<NotFound />} />
        <Route path="/:pid/missingParams" element={<MissingParams />} />
        <Route path="/:pid/formatError" element={<FormatError />} />
        <Route
          path="/:pid/success"
          element={<Success completionMessage={completionMessage} />}
        />

        {/* ============ 我國工作條件調查(要放在保留字以後) ============ */}
        <Route path="/P250603155903216/:uid" element={<P250603155903216 />} />
        <Route path="/P250528175251672/:uid" element={<P250528175251672 />} />

        {/* ============ 114年高放選址立法草案調查問卷 ============ */}
        {/* <Route path="/P250805175342648/:uid" element={<P250805175342648 />} /> */}

        <Route
          path="/computex-2024-success"
          element={<SuccessComputex completionMessage={completionMessage} />}
        />
        <Route
          path="/computex-2025-success"
          element={
            <SuccessComputex2025 completionMessage={completionMessage} />
          }
        />
        <Route
          path="/ha/:pid/dkabio-success"
          element={
            <SuccessDkabio
              completionMessage={completionMessage}
              setIsDkabio={setIsDkabio}
            />
          }
        />
        {/* 有流水編號的 */}
        {routesConfigWithSerialNum.map(({ path, component: Component }) => (
          <Route
            key={`${path}_serial_num`}
            path={`${path}/:serial_num`}
            element={<Component setCompletionMessage={setCompletionMessage} />}
          />
        ))}
        {/* ha app 邁達特健康問卷 */}
        <Route
          path="/ha/:user_id/:access_token/:member_mission_id"
          element={
            <P240703185556 setCompletionMessage={setCompletionMessage} />
          }
        />
        <Route
          path="/ha-task/:pid/:access_token/:member_mission_id"
          element={
            <HaTask
              setCompletionMessage={setCompletionMessage}
              setIsDkabio={setIsDkabio}
            />
          }
        />
        <Route
          path="/ha/:pid"
          element={
            <Template
              setCompletionMessage={setCompletionMessage}
              setIsDkabio={setIsDkabio}
            />
          }
        />
        <Route
          path="/ha/:pid/:access_token/:member_mission_id/:user_id"
          element={
            <HaTaskWithUserId
              setCompletionMessage={setCompletionMessage}
              setIsDkabio={setIsDkabio}
            />
          }
        />
        {/* 2025 醫療展 */}
        <Route
          path="/ha/P241108105538703/:access_token/:member_mission_id"
          element={
            <P241108105538703
              setCompletionMessage={setCompletionMessage}
              setIsDkabio={setIsDkabio}
            />
          }
        />
        {/* <Route
            path="/ha"
            element={
              <P240703185556 setCompletionMessage={setCompletionMessage} />
            }
          /> */}
        <Route path="/P240719175039533" element={<NotFound />} />
        <Route path="/P240703185556" element={<NotFound />} />
        <Route
          path="/gift-status-2025"
          element={<Computex2025GetGiftStatus />}
        />
        <Route
          path="/questionnaireSkipConverter"
          element={<QuestionnaireSkipConverter />}
        />

        <Route path="*" element={<NotFound />} />
      </Routes>

      <div className="logo">
        {isDkabio ? (
          <>
            <img
              className="logoWrap"
              src={dkabioLogo}
              alt="dkabio-logo"
              style={{ width: '160px' }}
            />
          </>
        ) : (
          <>
            <img className="logoWrap" src={ezcLogo} alt="ezc-logo" />
            <div className="poweredBy">Powered by EZChoice © 2024</div>
          </>
        )}
      </div>
    </SurveyParamsContext.Provider>
  )
}

export default App
